<template>
  <div class="row" style="width:100%">
    <div class="col-12 mt-2">
      <l-map ref="mapControl" :zoom="zoom" style="height: 500px; width: 100%">
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-geo-json v-for="(map, index) in geojson" :key="index" ref="jsonLayer" :geojson="JSON.parse(map)" />
      </l-map>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LGeoJson } from "vue2-leaflet";

export default {
  props: {
    data: { type: Array, required: true },
  },
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
  },
  data() {
    return {
      zoom: 8,
      geojson: null,
      fillColor: "#e4ce7f",
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    };
  },
  async created() {
    this.geojson = this.data;
  },
  mounted() {
    this.displayMap();
  },
  computed: {
    styleFunction() {
      const fillColor = this.fillColor; // important! need touch fillColor in computed for re-calculate when change fillColor
      return () => {
        return {
          weight: 2,
          color: "#ECEFF1",
          opacity: 1,
          fillColor: fillColor,
          fillOpacity: 1
        };
      };
    },
  },
  methods: {
    displayMap() {
      this.$nextTick(function () {
        var bounds = this.$refs.jsonLayer[0].getBounds();
        for (var i = 1; i < this.$refs.jsonLayer.length; i++) {
          bounds.extend(this.$refs.jsonLayer[i].getBounds());
        }
        this.$refs.mapControl.fitBounds(bounds);
      }, 500);
    }
  }
};
</script>